import  gql  from 'graphql-tag'

export const SHARE_GENERAL_BALANCE_EMAIL = gql`mutation shareGeneralBalanceByEmail($input: ShareGeneralBalanceByEmailMutationInput!){
    shareGeneralBalanceByEmail(input: $input){
        errors{
            field
            messages
        }
    }
}`;